import {
  takeEvery,
  takeLatest,
  put,
  call,
  all,
  fork,
} from "redux-saga/effects";

import {
  GET_STAFF_DATA,
  ADD_NEW_STAFF,
  UPDATE_STAFF,
  DELETE_STAFF,
  GET_STAFF_LIST,
  SEARCH_STAFF_INCOME_LIST,
  GET_STAFF_LEAVE_TYPE_LIST,
  ADD_STAFF_LEAVE_TYPE,
  UPDATE_STAFF_LEAVE_TYPE,
  DELETE_STAFF_LEAVE_TYPE,
  CREATE_STAFF_INCOME,
  GET_STAFF_INCOME_CATEGORY_ITEM_LIST,
  GET_STAFF_INCOME_CATEGORY_ITEM_DATA,
  CREATE_STAFF_INCOME_CATEGORY_ITEM,
  UPDATE_STAFF_INCOME_CATEGORY_ITEM,
  DELETE_STAFF_INCOME_CATEGORY_ITEM,
  GET_STAFF_INCOME_LIST,
  GET_STAFF_INCOME_DATA,
  UPDATE_STAFF_INCOME,
  DELETE_STAFF_INCOME,
  GET_STAFF_LEAVE_LIST,
  GET_STAFF_LEAVE_DATA,
  UPDATE_STAFF_LEAVE,
  DELETE_STAFF_LEAVE,
  CREATE_STAFF_LEAVE,
  SEARCH_STAFF_LEAVE,
  GET_STAFF_LEAVE_ALLOWANCE_LIST,
  GET_STAFF_LEAVE_ALLOWANCE_DATA,
  UPDATE_STAFF_LEAVE_ALLOWANCE,
  DELETE_STAFF_LEAVE_ALLOWANCE,
  CREATE_STAFF_LEAVE_ALLOWANCE,
  SEARCH_STAFF_LEAVE_ALLOWANCE,
  SEARCH_STAFF,
  SEARCH_STAFF_MEMBERS,
  CREATE_STAFF_AND_USER,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST,
  GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA,
  CREATE_ORGANISATION_DEPARTMENT_TO_STAFF,
  SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF,
  UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF,
  DELETE_ORGANISATION_DEPARTMENT_TO_STAFF,
  GET_ORGANISATION_DEPARTMENT_LIST,
  GET_ORGANISATION_DEPARTMENT_DATA,
  CREATE_ORGANISATION_DEPARTMENT,
  GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY,
  UPDATE_ORGANISATION_DEPARTMENT,
  DELETE_ORGANISATION_DEPARTMENT,
  GET_STAFF_TO_STAFF_MANAGER_LIST,
  GET_STAFF_TO_STAFF_MANAGER_DATA,
  CREATE_STAFF_TO_STAFF_MANAGER,
  UPDATE_STAFF_TO_STAFF_MANAGER,
  DELETE_STAFF_TO_STAFF_MANAGER,
  GET_STAFF_RECENT_ACTIVITY_LIST,
  STAFF_ACTIVITY_LOG_SEARCH,
  SEARCH_STAFF_REAL_TIME,
  GET_STAFF_SKILL_SET_LIST,
  GET_STAFF_SKILL_SET_DATA,
  CREATE_STAFF_SKILL_SET,
  UPDATE_STAFF_SKILL_SET,
  DELETE_STAFF_SKILL_SET,
  GET_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST,
  GET_STAFF_TO_STAFF_SKILL_SET_DATA,
  CREATE_STAFF_TO_STAFF_SKILL_SET,
  UPDATE_STAFF_TO_STAFF_SKILL_SET,
  DELETE_STAFF_TO_STAFF_SKILL_SET,
  SEARCH_STAFF_TO_STAFF_SKILL_SET,
  SEARCH_STAFF_AVAILABILITY,
  SEARCH_STAFF_GPS_LOCATION_HISTORY,
  GET_STAFF_WORKING_SCHEDULE_RECORD_LIST,
  GET_STAFF_WORKING_SCHEDULE_RECORD_DATA,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST,
  GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA,
  CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
  GET_STAFF_WORKING_SCHEDULE_LIST,
  GET_STAFF_WORKING_SCHEDULE_DATA,
  CREATE_STAFF_WORKING_SCHEDULE,
  UPDATE_STAFF_WORKING_SCHEDULE,
  DELETE_STAFF_WORKING_SCHEDULE,
  SEARCH_STAFF_WORKING_SCHEDULE,
  SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE,
  CALCULATE_STAFF_WORKING_SCHEDULE,
} from "./actionType";

import {
  addStaffSuccess,
  addStaffFail,
  getStaffDataSuccess,
  getStaffDataFail,
  updateStaffSuccess,
  updateStaffFail,
  deleteStaffSuccess,
  deleteStaffFail,
  getStaffListSuccess,
  getStaffListFail,
  searchStaffIncomeListSuccess,
  searchStaffIncomeListFail,
  getStaffLeaveTypeListSuccess,
  getStaffLeaveTypeListFail,
  addStaffLeaveTypeSuccess,
  addStaffLeaveTypeFail,
  updateStaffLeaveTypeSuccess,
  updateStaffLeaveTypeFail,
  deleteStaffLeaveTypeSuccess,
  deleteStaffLeaveTypeFail,
  createStaffIncomeSuccess,
  createStaffIncomeFail,
  getStaffIncomeCategoryItemListSuccess,
  getStaffIncomeCategoryItemListFail,
  getStaffIncomeCategoryItemDataSuccess,
  getStaffIncomeCategoryItemDataFail,
  createStaffIncomeCategoryItemSuccess,
  createStaffIncomeCategoryItemFail,
  updateStaffIncomeCategoryItemSuccess,
  updateStaffIncomeCategoryItemFail,
  deleteStaffIncomeCategoryItemSuccess,
  deleteStaffIncomeCategoryItemFail,
  getStaffIncomeListSuccess,
  getStaffIncomeListFail,
  getStaffIncomeDataSuccess,
  getStaffIncomeDataFail,
  updateStaffIncomeSuccess,
  updateStaffIncomeFail,
  deleteStaffIncomeSuccess,
  deleteStaffIncomeFail,
  getSingleStaffLeaveListSuccess,
  getSingleStaffLeaveListFail,
  getStaffLeaveDataSuccess,
  getStaffLeaveDataFail,
  updateStaffLeaveSuccess,
  updateStaffLeaveFail,
  deleteStaffLeaveSuccess,
  deleteStaffLeaveFail,
  createStaffLeaveSuccess,
  createStaffLeaveFail,
  searchStaffLeaveSuccess,
  searchStaffLeaveFail,
  getStaffLeaveAllowanceListSuccess,
  getStaffLeaveAllowanceListFail,
  getStaffLeaveAllowanceDataSuccess,
  getStaffLeaveAllowanceDataFail,
  updateStaffLeaveAllowanceSuccess,
  updateStaffLeaveAllowanceFail,
  deleteStaffLeaveAllowanceSuccess,
  deleteStaffLeaveAllowanceFail,
  createStaffLeaveAllowanceSuccess,
  createStaffLeaveAllowanceFail,
  searchStaffLeaveAllowanceSuccess,
  searchStaffLeaveAllowanceFail,
  searchStaffSuccess,
  searchStaffFail,
  searchStaffMembersSuccess,
  searchStaffMembersFail,
  createStaffAndUserSuccess,
  createStaffAndUserFail,
  getOrganisationDepartmentToStaffListSuccess,
  getOrganisationDepartmentToStaffListFail,
  getOrganisationDepartmentToStaffDataSuccess,
  getOrganisationDepartmentToStaffDataFail,
  createOrganisationDepartmentToStaffSuccess,
  createOrganisationDepartmentToStaffFail,
  searchOrganisationDepartmentToStaffSuccess,
  searchOrganisationDepartmentToStaffFail,
  updateOrganisationDepartmentToStaffSuccess,
  updateOrganisationDepartmentToStaffFail,
  deleteOrganisationDepartmentToStaffSuccess,
  deleteOrganisationDepartmentToStaffFail,
  getOrganisationDepartmentListSuccess,
  getOrganisationDepartmentListFail,
  getOrganisationDepartmentDataSuccess,
  getOrganisationDepartmentDataFail,
  createOrganisationDepartmentSuccess,
  createOrganisationDepartmentFail,
  getOrganisationDepartmentHierarchyEnquirySuccess,
  getOrganisationDepartmentHierarchyEnquiryFail,
  updateOrganisationDepartmentSuccess,
  updateOrganisationDepartmentFail,
  deleteOrganisationDepartmentSuccess,
  deleteOrganisationDepartmentFail,
  getStaffToStaffManagerListSuccess,
  getStaffToStaffManagerListFail,
  getStaffToStaffManagerDataSuccess,
  getStaffToStaffManagerDataFail,
  createStaffToStaffManagerSuccess,
  createStaffToStaffManagerFail,
  updateStaffToStaffManagerSuccess,
  updateStaffToStaffManagerFail,
  deleteStaffToStaffManagerSuccess,
  deleteStaffToStaffManagerFail,
  getStaffRecentActivityListSuccess,
  getStaffRecentActivityListFail,
  staffActivityLogSearchSuccess,
  staffActivityLogSearchFailure,
  searchStaffRealTimeSuccess,
  searchStaffRealTimeFail,
  //staff skill set actions
  getStaffSkillSetListSuccess,
  getStaffSkillSetListFail,
  getStaffSkillSetDataSuccess,
  getStaffSkillSetDataFail,
  createStaffSkillSetSuccess,
  createStaffSkillSetFail,
  updateStaffSkillSetSuccess,
  updateStaffSkillSetFail,
  deleteStaffSkillSetSuccess,
  deleteStaffSkillSetFail,
  getStaffToStaffSkillSetListSuccess,
  getStaffToStaffSkillSetListFail,
  getActiveStaffToStaffSkillSetListSuccess,
  getActiveStaffToStaffSkillSetListFail,
  getExpiredStaffToStaffSkillSetListSuccess,
  getExpiredStaffToStaffSkillSetListFail,
  getStaffToStaffSkillSetDataSuccess,
  getStaffToStaffSkillSetDataFail,
  createStaffToStaffSkillSetSuccess,
  createStaffToStaffSkillSetFail,
  updateStaffToStaffSkillSetSuccess,
  updateStaffToStaffSkillSetFail,
  deleteStaffToStaffSkillSetSuccess,
  deleteStaffToStaffSkillSetFail,
  searchStaffToStaffSkillSetSuccess,
  searchStaffToStaffSkillSetFail,
  searchStaffAvailabilitySuccess,
  searchStaffAvailabilityFail,
  searchStaffGPSLocationHistorySuccess,
  searchStaffGPSLocationHistoryFail,
  getStaffWorkingScheduleRecordListSuccess,
  getStaffWorkingScheduleRecordListFail,
  getStaffWorkingScheduleRecordDataSuccess,
  getStaffWorkingScheduleRecordDataFail,
  createStaffWorkingScheduleRecordSuccess,
  createStaffWorkingScheduleRecordFail,
  updateStaffWorkingScheduleRecordSuccess,
  updateStaffWorkingScheduleRecordFail,
  deleteStaffWorkingScheduleRecordSuccess,
  deleteStaffWorkingScheduleRecordFail,
  getStaffWorkingScheduleRecordAdjustmentListSuccess,
  getStaffWorkingScheduleRecordAdjustmentListFail,
  getStaffWorkingScheduleRecordAdjustmentDataSuccess,
  getStaffWorkingScheduleRecordAdjustmentDataFail,
  createStaffWorkingScheduleRecordAdjustmentSuccess,
  createStaffWorkingScheduleRecordAdjustmentFail,
  updateStaffWorkingScheduleRecordAdjustmentSuccess,
  updateStaffWorkingScheduleRecordAdjustmentFail,
  deleteStaffWorkingScheduleRecordAdjustmentSuccess,
  deleteStaffWorkingScheduleRecordAdjustmentFail,
  getStaffWorkingScheduleListSuccess,
  getStaffWorkingScheduleListFail,
  getStaffWorkingScheduleDataSuccess,
  getStaffWorkingScheduleDataFail,
  createStaffWorkingScheduleSuccess,
  createStaffWorkingScheduleFail,
  updateStaffWorkingScheduleSuccess,
  updateStaffWorkingScheduleFail,
  deleteStaffWorkingScheduleSuccess,
  deleteStaffWorkingScheduleFail,
  searchStaffWorkingScheduleSuccess,
  searchStaffWorkingScheduleFail,
  searchStaffWorkingScheduleForCloneSuccess,
  searchStaffWorkingScheduleForCloneFail,
  calculateStaffWorkingScheduleSuccess,
  calculateStaffWorkingScheduleFail,
} from "./action";

import {
  addNewStaff,
  getStaffDataAPI,
  updateStaff,
  deleteStaff,
  getStaffListApi,
  searchStaffIncomeListApi,
  getStaffLeaveTypeListApi,
  addStaffLeaveTypeApi,
  updateStaffLeaveTypeApi,
  deleteStaffLeaveTypeApi,
  createStaffIncomeApi,
  getStaffIncomeCategoryItemListApi,
  getStaffIncomeCategoryItemDataApi,
  createStaffIncomeCategoryItemApi,
  updateStaffIncomeCategoryItemApi,
  deleteStaffIncomeCategoryItemApi,
  getStaffIncomeListApi,
  getStaffIncomeDataApi,
  updateStaffIncomeApi,
  deleteStaffIncomeApi,
  getStaffLeaveListApi,
  getStaffLeaveDataApi,
  updateStaffLeaveApi,
  deleteStaffLeaveApi,
  createStaffLeaveApi,
  searchStaffLeaveApi,
  getStaffLeaveAllowanceListApi,
  getStaffLeaveAllowanceDataApi,
  updateStaffLeaveAllowanceApi,
  deleteStaffLeaveAllowanceApi,
  createStaffLeaveAllowanceApi,
  searchStaffLeaveAllowanceApi,
  searchStaffApi,
  searchStaffMembersApi,
  createStaffAndUserApi,
  getOrganisationDepartmentToStaffListApi,
  getOrganisationDepartmentToStaffDataApi,
  createOrganisationDepartmentToStaffApi,
  searchOrganisationDepartmentToStaffApi,
  updateOrganisationDepartmentToStaffApi,
  deleteOrganisationDepartmentToStaffApi,
  getOrganisationDepartmentListApi,
  getOrganisationDepartmentDataApi,
  createOrganisationDepartmentApi,
  getOrganisationDepartmentHierarchyEnquiryApi,
  updateOrganisationDepartmentApi,
  deleteOrganisationDepartmentApi,
  getStaffToStaffManagerListApi,
  getStaffToStaffManagerDataApi,
  createStaffToStaffManagerApi,
  updateStaffToStaffManagerApi,
  deleteStaffToStaffManagerApi,
  getStaffRecentActivityListApi,
  staffActivityLogSearchApi,
  searchStaffRealTimeApi,
  getStaffSkillSetListApi,
  getStaffSkillSetDataApi,
  createStaffSkillSetApi,
  updateStaffSkillSetApi,
  deleteStaffSkillSetApi,
  getStaffToStaffSkillSetListApi,
  getActiveStaffToStaffSkillSetListApi,
  getExpiredStaffToStaffSkillSetListApi,
  getStaffToStaffSkillSetDataApi,
  createStaffToStaffSkillSetApi,
  updateStaffToStaffSkillSetApi,
  deleteStaffToStaffSkillSetApi,
  searchStaffToStaffSkillSetApi,
  searchStaffAvailabilityApi,
  searchStaffGPSLocationHistoryApi,
  getStaffWorkingScheduleRecordListApi,
  getStaffWorkingScheduleRecordDataApi,
  createStaffWorkingScheduleRecordApi,
  updateStaffWorkingScheduleRecordApi,
  deleteStaffWorkingScheduleRecordApi,
  getStaffWorkingScheduleRecordAdjustmentListApi,
  getStaffWorkingScheduleRecordAdjustmentDataApi,
  createStaffWorkingScheduleRecordAdjustmentApi,
  updateStaffWorkingScheduleRecordAdjustmentApi,
  deleteStaffWorkingScheduleRecordAdjustmentApi,
  getStaffWorkingScheduleListApi,
  getStaffWorkingScheduleDataApi,
  createStaffWorkingScheduleApi,
  updateStaffWorkingScheduleApi,
  deleteStaffWorkingScheduleApi,
  searchStaffWorkingScheduleApi,
  calculateStaffWorkingScheduleApi,
} from "../../helpers/fakebackend_helper";

//add new staff
function* onAddStaff({ payload }) {
  try {
    const response = yield call(addNewStaff, payload);
    // FetchAPI resolves to the parsed body, not an axios-style {data}.
    if (response) {
      yield put(addStaffSuccess(response));
    } else {
      yield put(addStaffFail(response));
    }
  } catch (error) {
    yield put(addStaffFail(error));
  }
}

export function* watchAddStaff() {
  yield takeEvery(ADD_NEW_STAFF, onAddStaff);
}

//get staff data
function* getStaffData(action) {
  try {
    const response = yield call(getStaffDataAPI, action.payload);
    if (response) {
      yield put(getStaffDataSuccess(response));
    } else {
      yield put(getStaffDataFail(response));
    }
  } catch (error) {
    yield put(getStaffDataFail(error));
  }
}

export function* watchGetStaffData() {
  yield takeEvery(GET_STAFF_DATA, getStaffData);
}

//update staff
function* onUpdateStaff({ payload }) {
  try {
    const response = yield call(updateStaff, payload);
    // FetchAPI resolves to the parsed body, not an axios-style {data}.
    if (response) {
      yield put(updateStaffSuccess(response));
    } else {
      yield put(updateStaffFail(response));
    }
  } catch (error) {
    yield put(updateStaffFail(error));
  }
}

export function* watchUpdateStaff() {
  yield takeEvery(UPDATE_STAFF, onUpdateStaff);
}
//delete staff
function* onDeleteStaff({ payload }) {
  try {
    const response = yield call(deleteStaff, payload);
    // FetchAPI resolves to the parsed body, not an axios-style {data}.
    if (response) {
      yield put(deleteStaffSuccess(response));
    } else {
      yield put(deleteStaffFail(response));
    }
  } catch (error) {
    yield put(deleteStaffFail(error));
  }
}

//get staff list
function* onGetStaffList() {
  try {
    const response = yield call(getStaffListApi);
    if (response) {
      yield put(getStaffListSuccess(response));
    } else {
      yield put(getStaffListFail(response));
    }
  } catch (error) {
    yield put(getStaffListFail(error));
  }
}

export function* watchGetStaffList() {
  yield takeEvery(GET_STAFF_LIST, onGetStaffList);
}

export function* watchDeleteStaff() {
  yield takeEvery(DELETE_STAFF, onDeleteStaff);
}
//search staff income list
function* onSearchStaffIncomeList({ payload }) {
  try {
    const response = yield call(searchStaffIncomeListApi, payload);
    if (response) {
      yield put(searchStaffIncomeListSuccess(response));
    } else {
      yield put(searchStaffIncomeListFail(response));
    }
  } catch (error) {
    yield put(searchStaffIncomeListFail(error));
  }
}

export function* watchSearchStaffIncomeList() {
  yield takeEvery(SEARCH_STAFF_INCOME_LIST, onSearchStaffIncomeList);
}

//get staff leave type list
function* onGetStaffLeaveTypeList() {
  try {
    const response = yield call(getStaffLeaveTypeListApi);
    if (response) {
      yield put(getStaffLeaveTypeListSuccess(response));
    } else {
      yield put(getStaffLeaveTypeListFail(response));
    }
  } catch (error) {
    yield put(getStaffLeaveTypeListFail(error));
  }
}

export function* watchGetStaffLeaveTypeList() {
  yield takeEvery(GET_STAFF_LEAVE_TYPE_LIST, onGetStaffLeaveTypeList);
}

//add staff leave type
function* onAddStaffLeaveType({ payload }) {
  try {
    const response = yield call(addStaffLeaveTypeApi, payload);
    if (response) {
      yield put(addStaffLeaveTypeSuccess(response));
    } else {
      yield put(addStaffLeaveTypeFail(response));
    }
  } catch (error) {
    yield put(addStaffLeaveTypeFail(error));
  }
}

export function* watchAddStaffLeaveType() {
  yield takeEvery(ADD_STAFF_LEAVE_TYPE, onAddStaffLeaveType);
}

//update staff leave type
function* onUpdateStaffLeaveType({ payload }) {
  try {
    const response = yield call(updateStaffLeaveTypeApi, payload);
    if (response) {
      yield put(updateStaffLeaveTypeSuccess(response));
    } else {
      yield put(updateStaffLeaveTypeFail(response));
    }
  } catch (error) {
    yield put(updateStaffLeaveTypeFail(error));
  }
}

export function* watchUpdateStaffLeaveType() {
  yield takeEvery(UPDATE_STAFF_LEAVE_TYPE, onUpdateStaffLeaveType);
}

//delete staff leave type
function* onDeleteStaffLeaveType({ payload }) {
  try {
    const response = yield call(deleteStaffLeaveTypeApi, payload);
    if (response) {
      yield put(deleteStaffLeaveTypeSuccess(response));
    } else {
      yield put(deleteStaffLeaveTypeFail(response));
    }
  } catch (error) {
    yield put(deleteStaffLeaveTypeFail(error));
  }
}

export function* watchDeleteStaffLeaveType() {
  yield takeEvery(DELETE_STAFF_LEAVE_TYPE, onDeleteStaffLeaveType);
}

//create staff income
function* onCreateStaffIncome({ payload }) {
  try {
    const response = yield call(createStaffIncomeApi, payload);
    if (response) {
      yield put(createStaffIncomeSuccess(response));
    } else {
      yield put(createStaffIncomeFail(response));
    }
  } catch (error) {
    yield put(createStaffIncomeFail(error));
  }
}

export function* watchCreateStaffIncome() {
  yield takeEvery(CREATE_STAFF_INCOME, onCreateStaffIncome);
}

//get staff income category item list
function* onGetStaffIncomeCategoryItemList() {
  try {
    const response = yield call(getStaffIncomeCategoryItemListApi);
    if (response) {
      yield put(getStaffIncomeCategoryItemListSuccess(response));
    } else {
      yield put(getStaffIncomeCategoryItemListFail(response));
    }
  } catch (error) {
    yield put(getStaffIncomeCategoryItemListFail(error));
  }
}

export function* watchGetStaffIncomeCategoryItemList() {
  yield takeEvery(
    GET_STAFF_INCOME_CATEGORY_ITEM_LIST,
    onGetStaffIncomeCategoryItemList
  );
}

//get staff income category item data
function* onGetStaffIncomeCategoryItemData({ payload }) {
  try {
    const response = yield call(getStaffIncomeCategoryItemDataApi, payload);
    if (response) {
      yield put(getStaffIncomeCategoryItemDataSuccess(response));
    } else {
      yield put(getStaffIncomeCategoryItemDataFail(response));
    }
  } catch (error) {
    yield put(getStaffIncomeCategoryItemDataFail(error));
  }
}

export function* watchGetStaffIncomeCategoryItemData() {
  yield takeEvery(
    GET_STAFF_INCOME_CATEGORY_ITEM_DATA,
    onGetStaffIncomeCategoryItemData
  );
}

//create staff income category item
function* onCreateStaffIncomeCategoryItem({ payload }) {
  try {
    const response = yield call(createStaffIncomeCategoryItemApi, payload);
    if (response) {
      yield put(createStaffIncomeCategoryItemSuccess(response));
    } else {
      yield put(createStaffIncomeCategoryItemFail(response));
    }
  } catch (error) {
    yield put(createStaffIncomeCategoryItemFail(error));
  }
}

export function* watchCreateStaffIncomeCategoryItem() {
  yield takeEvery(
    CREATE_STAFF_INCOME_CATEGORY_ITEM,
    onCreateStaffIncomeCategoryItem
  );
}

//update staff income category item
function* onUpdateStaffIncomeCategoryItem({ payload }) {
  try {
    const response = yield call(updateStaffIncomeCategoryItemApi, payload);
    if (response) {
      yield put(updateStaffIncomeCategoryItemSuccess(response));
    } else {
      yield put(updateStaffIncomeCategoryItemFail(response));
    }
  } catch (error) {
    yield put(updateStaffIncomeCategoryItemFail(error));
  }
}

export function* watchUpdateStaffIncomeCategoryItem() {
  yield takeEvery(
    UPDATE_STAFF_INCOME_CATEGORY_ITEM,
    onUpdateStaffIncomeCategoryItem
  );
}

//delete staff income category item
function* onDeleteStaffIncomeCategoryItem({ payload }) {
  try {
    const response = yield call(deleteStaffIncomeCategoryItemApi, payload);
    if (response) {
      yield put(deleteStaffIncomeCategoryItemSuccess(response));
    } else {
      yield put(deleteStaffIncomeCategoryItemFail(response));
    }
  } catch (error) {
    yield put(deleteStaffIncomeCategoryItemFail(error));
  }
}

export function* watchDeleteStaffIncomeCategoryItem() {
  yield takeEvery(
    DELETE_STAFF_INCOME_CATEGORY_ITEM,
    onDeleteStaffIncomeCategoryItem
  );
}

//get staff income list
function* onGetStaffIncomeList() {
  try {
    const response = yield call(getStaffIncomeListApi);
    if (response) {
      yield put(getStaffIncomeListSuccess(response));
    } else {
      yield put(getStaffIncomeListFail(response));
    }
  } catch (error) {
    yield put(getStaffIncomeListFail(error));
  }
}

export function* watchGetStaffIncomeList() {
  yield takeEvery(GET_STAFF_INCOME_LIST, onGetStaffIncomeList);
}

//get staff income data
function* onGetStaffIncomeData({ payload }) {
  try {
    const response = yield call(getStaffIncomeDataApi, payload);
    if (response) {
      yield put(getStaffIncomeDataSuccess(response));
    } else {
      yield put(getStaffIncomeDataFail(response));
    }
  } catch (error) {
    yield put(getStaffIncomeDataFail(error));
  }
}

export function* watchGetStaffIncomeData() {
  yield takeEvery(GET_STAFF_INCOME_DATA, onGetStaffIncomeData);
}

//update staff income
function* onUpdateStaffIncome({ payload }) {
  try {
    const response = yield call(updateStaffIncomeApi, payload);
    if (response) {
      yield put(updateStaffIncomeSuccess(response));
    } else {
      yield put(updateStaffIncomeFail(response));
    }
  } catch (error) {
    yield put(updateStaffIncomeFail(error));
  }
}

export function* watchUpdateStaffIncome() {
  yield takeEvery(UPDATE_STAFF_INCOME, onUpdateStaffIncome);
}

//delete staff income
function* onDeleteStaffIncome({ payload }) {
  try {
    const response = yield call(deleteStaffIncomeApi, payload);
    if (response) {
      yield put(deleteStaffIncomeSuccess(response));
    } else {
      yield put(deleteStaffIncomeFail(response));
    }
  } catch (error) {
    yield put(deleteStaffIncomeFail(error));
  }
}

export function* watchDeleteStaffIncome() {
  yield takeEvery(DELETE_STAFF_INCOME, onDeleteStaffIncome);
}

//get staff leave list
function* onGetStaffLeaveList() {
  try {
    const response = yield call(getStaffLeaveListApi);
    if (response) {
      yield put(getSingleStaffLeaveListSuccess(response));
    } else {
      yield put(getSingleStaffLeaveListFail(response));
    }
  } catch (error) {
    yield put(getSingleStaffLeaveListFail(error));
  }
}

export function* watchGetStaffLeaveList() {
  yield takeEvery(GET_STAFF_LEAVE_LIST, onGetStaffLeaveList);
}

//get staff leave data
function* onGetStaffLeaveData({ payload }) {
  try {
    const response = yield call(getStaffLeaveDataApi, payload);
    if (response) {
      yield put(getStaffLeaveDataSuccess(response));
    } else {
      yield put(getStaffLeaveDataFail(response));
    }
  } catch (error) {
    yield put(getStaffLeaveDataFail(error));
  }
}

export function* watchGetStaffLeaveData() {
  yield takeEvery(GET_STAFF_LEAVE_DATA, onGetStaffLeaveData);
}

//update staff leave
function* onUpdateStaffLeave({ payload }) {
  try {
    const response = yield call(updateStaffLeaveApi, payload);
    if (response) {
      yield put(updateStaffLeaveSuccess(response));
    } else {
      yield put(updateStaffLeaveFail(response));
    }
  } catch (error) {
    yield put(updateStaffLeaveFail(error));
  }
}

export function* watchUpdateStaffLeave() {
  yield takeEvery(UPDATE_STAFF_LEAVE, onUpdateStaffLeave);
}

//delete staff leave
function* onDeleteStaffLeave({ payload }) {
  try {
    const response = yield call(deleteStaffLeaveApi, payload);
    if (response) {
      yield put(deleteStaffLeaveSuccess(response));
    } else {
      yield put(deleteStaffLeaveFail(response));
    }
  } catch (error) {
    yield put(deleteStaffLeaveFail(error));
  }
}

export function* watchDeleteStaffLeave() {
  yield takeEvery(DELETE_STAFF_LEAVE, onDeleteStaffLeave);
}

//create staff leave
function* onCreateStaffLeave({ payload }) {
  try {
    const response = yield call(createStaffLeaveApi, payload);
    if (response) {
      yield put(createStaffLeaveSuccess(response));
    } else {
      yield put(createStaffLeaveFail(response));
    }
  } catch (error) {
    yield put(createStaffLeaveFail(error));
  }
}

export function* watchCreateStaffLeave() {
  yield takeEvery(CREATE_STAFF_LEAVE, onCreateStaffLeave);
}

//search staff leave
function* onSearchStaffLeave({ payload }) {
  try {
    const response = yield call(searchStaffLeaveApi, payload);
    if (response) {
      yield put(searchStaffLeaveSuccess(response));
    } else {
      yield put(searchStaffLeaveFail(response));
    }
  } catch (error) {
    yield put(searchStaffLeaveFail(error));
  }
}

export function* watchSearchStaffLeave() {
  yield takeEvery(SEARCH_STAFF_LEAVE, onSearchStaffLeave);
}

//get staff leave allowance list
function* onGetStaffLeaveAllowanceList() {
  try {
    const response = yield call(getStaffLeaveAllowanceListApi);
    if (response) {
      yield put(getStaffLeaveAllowanceListSuccess(response));
    } else {
      yield put(getStaffLeaveAllowanceListFail(response));
    }
  } catch (error) {
    yield put(getStaffLeaveAllowanceListFail(error));
  }
}

export function* watchGetStaffLeaveAllowanceList() {
  yield takeEvery(GET_STAFF_LEAVE_ALLOWANCE_LIST, onGetStaffLeaveAllowanceList);
}

//get staff leave allowance data
function* onGetStaffLeaveAllowanceData({ payload }) {
  try {
    const response = yield call(getStaffLeaveAllowanceDataApi, payload);
    if (response) {
      yield put(getStaffLeaveAllowanceDataSuccess(response));
    } else {
      yield put(getStaffLeaveAllowanceDataFail(response));
    }
  } catch (error) {
    yield put(getStaffLeaveAllowanceDataFail(error));
  }
}

export function* watchGetStaffLeaveAllowanceData() {
  yield takeEvery(GET_STAFF_LEAVE_ALLOWANCE_DATA, onGetStaffLeaveAllowanceData);
}

//update staff leave allowance
function* onUpdateStaffLeaveAllowance({ payload }) {
  try {
    const response = yield call(updateStaffLeaveAllowanceApi, payload);
    if (response) {
      yield put(updateStaffLeaveAllowanceSuccess(response));
    } else {
      yield put(updateStaffLeaveAllowanceFail(response));
    }
  } catch (error) {
    yield put(updateStaffLeaveAllowanceFail(error));
  }
}

export function* watchUpdateStaffLeaveAllowance() {
  yield takeEvery(UPDATE_STAFF_LEAVE_ALLOWANCE, onUpdateStaffLeaveAllowance);
}

//delete staff leave allowance
function* onDeleteStaffLeaveAllowance({ payload }) {
  try {
    const response = yield call(deleteStaffLeaveAllowanceApi, payload);
    if (response) {
      yield put(deleteStaffLeaveAllowanceSuccess(response));
    } else {
      yield put(deleteStaffLeaveAllowanceFail(response));
    }
  } catch (error) {
    yield put(deleteStaffLeaveAllowanceFail(error));
  }
}

export function* watchDeleteStaffLeaveAllowance() {
  yield takeEvery(DELETE_STAFF_LEAVE_ALLOWANCE, onDeleteStaffLeaveAllowance);
}

//create staff leave allowance
function* onCreateStaffLeaveAllowance({ payload }) {
  try {
    const response = yield call(createStaffLeaveAllowanceApi, payload);
    if (response) {
      yield put(createStaffLeaveAllowanceSuccess(response));
    } else {
      yield put(createStaffLeaveAllowanceFail(response));
    }
  } catch (error) {
    yield put(createStaffLeaveAllowanceFail(error));
  }
}

export function* watchCreateStaffLeaveAllowance() {
  yield takeEvery(CREATE_STAFF_LEAVE_ALLOWANCE, onCreateStaffLeaveAllowance);
}

//search staff leave allowance
function* onSearchStaffLeaveAllowance({ payload }) {
  try {
    const response = yield call(searchStaffLeaveAllowanceApi, payload);
    if (response) {
      yield put(searchStaffLeaveAllowanceSuccess(response));
    } else {
      yield put(searchStaffLeaveAllowanceFail(response));
    }
  } catch (error) {
    yield put(searchStaffLeaveAllowanceFail(error));
  }
}

export function* watchSearchStaffLeaveAllowance() {
  yield takeEvery(SEARCH_STAFF_LEAVE_ALLOWANCE, onSearchStaffLeaveAllowance);
}

//search staff
function* onSearchStaff({ payload }) {
  try {
    const response = yield call(searchStaffApi, payload);
    if (response) {
      yield put(searchStaffSuccess(response));
    } else {
      yield put(searchStaffFail(response));
    }
  } catch (error) {
    yield put(searchStaffFail(error));
  }
}

export function* watchSearchStaff() {
  yield takeEvery(SEARCH_STAFF, onSearchStaff);
}

//search staff members
function* onSearchStaffMembers({ payload }) {
  try {
    const response = yield call(searchStaffMembersApi, payload);
    if (response) {
      yield put(searchStaffMembersSuccess(response));
    } else {
      yield put(searchStaffMembersFail(response));
    }
  } catch (error) {
    yield put(searchStaffMembersFail(error));
  }
}

export function* watchSearchStaffMembers() {
  yield takeEvery(SEARCH_STAFF_MEMBERS, onSearchStaffMembers);
}

//create staff and user
function* onCreateStaffAndUser({ payload }) {
  try {
    const response = yield call(createStaffAndUserApi, payload);
    if (response) {
      yield put(createStaffAndUserSuccess(response));
    } else {
      yield put(createStaffAndUserFail(response));
    }
  } catch (error) {
    yield put(createStaffAndUserFail(error));
  }
}

export function* watchCreateStaffAndUser() {
  yield takeEvery(CREATE_STAFF_AND_USER, onCreateStaffAndUser);
}

//get organisation department to staff list
function* onGetOrganisationDepartmentToStaffList() {
  try {
    const response = yield call(getOrganisationDepartmentToStaffListApi);
    if (response) {
      yield put(getOrganisationDepartmentToStaffListSuccess(response));
    } else {
      yield put(getOrganisationDepartmentToStaffListFail(response));
    }
  } catch (error) {
    yield put(getOrganisationDepartmentToStaffListFail(error));
  }
}

export function* watchGetOrganisationDepartmentToStaffList() {
  yield takeEvery(
    GET_ORGANISATION_DEPARTMENT_TO_STAFF_LIST,
    onGetOrganisationDepartmentToStaffList
  );
}

//get organisation department to staff data
function* onGetOrganisationDepartmentToStaffData({ payload }) {
  try {
    const response = yield call(
      getOrganisationDepartmentToStaffDataApi,
      payload
    );
    if (response) {
      yield put(getOrganisationDepartmentToStaffDataSuccess(response));
    } else {
      yield put(getOrganisationDepartmentToStaffDataFail(response));
    }
  } catch (error) {
    yield put(getOrganisationDepartmentToStaffDataFail(error));
  }
}

export function* watchGetOrganisationDepartmentToStaffData() {
  yield takeEvery(
    GET_ORGANISATION_DEPARTMENT_TO_STAFF_DATA,
    onGetOrganisationDepartmentToStaffData
  );
}

//create organisation department to staff
function* onCreateOrganisationDepartmentToStaff({ payload }) {
  try {
    const response = yield call(
      createOrganisationDepartmentToStaffApi,
      payload
    );
    if (response) {
      yield put(createOrganisationDepartmentToStaffSuccess(response));
    } else {
      yield put(createOrganisationDepartmentToStaffFail(response));
    }
  } catch (error) {
    yield put(createOrganisationDepartmentToStaffFail(error));
  }
}

export function* watchCreateOrganisationDepartmentToStaff() {
  yield takeEvery(
    CREATE_ORGANISATION_DEPARTMENT_TO_STAFF,
    onCreateOrganisationDepartmentToStaff
  );
}

//search organisation department to staff
function* onSearchOrganisationDepartmentToStaff({ payload }) {
  try {
    const response = yield call(
      searchOrganisationDepartmentToStaffApi,
      payload
    );
    if (response) {
      yield put(searchOrganisationDepartmentToStaffSuccess(response));
    } else {
      yield put(searchOrganisationDepartmentToStaffFail(response));
    }
  } catch (error) {
    yield put(searchOrganisationDepartmentToStaffFail(error));
  }
}

export function* watchSearchOrganisationDepartmentToStaff() {
  yield takeEvery(
    SEARCH_ORGANISATION_DEPARTMENT_TO_STAFF,
    onSearchOrganisationDepartmentToStaff
  );
}

//update organisation department to staff
function* onUpdateOrganisationDepartmentToStaff({ payload }) {
  try {
    const response = yield call(
      updateOrganisationDepartmentToStaffApi,
      payload
    );
    if (response) {
      yield put(updateOrganisationDepartmentToStaffSuccess(response));
    } else {
      yield put(updateOrganisationDepartmentToStaffFail(response));
    }
  } catch (error) {
    yield put(updateOrganisationDepartmentToStaffFail(error));
  }
}

export function* watchUpdateOrganisationDepartmentToStaff() {
  yield takeEvery(
    UPDATE_ORGANISATION_DEPARTMENT_TO_STAFF,
    onUpdateOrganisationDepartmentToStaff
  );
}

//delete organisation department to staff
function* onDeleteOrganisationDepartmentToStaff({ payload }) {
  try {
    const response = yield call(
      deleteOrganisationDepartmentToStaffApi,
      payload
    );
    if (response) {
      yield put(deleteOrganisationDepartmentToStaffSuccess(response));
    } else {
      yield put(deleteOrganisationDepartmentToStaffFail(response));
    }
  } catch (error) {
    yield put(deleteOrganisationDepartmentToStaffFail(error));
  }
}

export function* watchDeleteOrganisationDepartmentToStaff() {
  yield takeEvery(
    DELETE_ORGANISATION_DEPARTMENT_TO_STAFF,
    onDeleteOrganisationDepartmentToStaff
  );
}

//get organisation department list
function* onGetOrganisationDepartmentList() {
  try {
    const response = yield call(getOrganisationDepartmentListApi);
    if (response) {
      yield put(getOrganisationDepartmentListSuccess(response));
    } else {
      yield put(getOrganisationDepartmentListFail(response));
    }
  } catch (error) {
    yield put(getOrganisationDepartmentListFail(error));
  }
}

export function* watchGetOrganisationDepartmentList() {
  yield takeEvery(
    GET_ORGANISATION_DEPARTMENT_LIST,
    onGetOrganisationDepartmentList
  );
}

//get organisation department data
function* onGetOrganisationDepartmentData({ payload }) {
  try {
    const response = yield call(getOrganisationDepartmentDataApi, payload);
    if (response) {
      yield put(getOrganisationDepartmentDataSuccess(response));
    } else {
      yield put(getOrganisationDepartmentDataFail(response));
    }
  } catch (error) {
    yield put(getOrganisationDepartmentDataFail(error));
  }
}

export function* watchGetOrganisationDepartmentData() {
  yield takeEvery(
    GET_ORGANISATION_DEPARTMENT_DATA,
    onGetOrganisationDepartmentData
  );
}

//create organisation department
function* onCreateOrganisationDepartment({ payload }) {
  try {
    const response = yield call(createOrganisationDepartmentApi, payload);
    if (response) {
      yield put(createOrganisationDepartmentSuccess(response));
    } else {
      yield put(createOrganisationDepartmentFail(response));
    }
  } catch (error) {
    yield put(createOrganisationDepartmentFail(error));
  }
}

export function* watchCreateOrganisationDepartment() {
  yield takeEvery(
    CREATE_ORGANISATION_DEPARTMENT,
    onCreateOrganisationDepartment
  );
}

//get organisation department hierarchy enquiry
function* onGetOrganisationDepartmentHierarchyEnquiry({ payload }) {
  try {
    const response = yield call(
      getOrganisationDepartmentHierarchyEnquiryApi,
      payload
    );
    if (response) {
      yield put(getOrganisationDepartmentHierarchyEnquirySuccess(response));
    } else {
      yield put(getOrganisationDepartmentHierarchyEnquiryFail(response));
    }
  } catch (error) {
    yield put(getOrganisationDepartmentHierarchyEnquiryFail(error));
  }
}

export function* watchGetOrganisationDepartmentHierarchyEnquiry() {
  yield takeEvery(
    GET_ORGANISATION_DEPARTMENT_HIERARCHY_ENQUIRY,
    onGetOrganisationDepartmentHierarchyEnquiry
  );
}

//update organisation department
function* onUpdateOrganisationDepartment({ payload }) {
  try {
    const response = yield call(updateOrganisationDepartmentApi, payload);
    if (response) {
      yield put(updateOrganisationDepartmentSuccess(response));
    } else {
      yield put(updateOrganisationDepartmentFail(response));
    }
  } catch (error) {
    yield put(updateOrganisationDepartmentFail(error));
  }
}

export function* watchUpdateOrganisationDepartment() {
  yield takeEvery(
    UPDATE_ORGANISATION_DEPARTMENT,
    onUpdateOrganisationDepartment
  );
}

//delete organisation department
function* onDeleteOrganisationDepartment({ payload }) {
  try {
    const response = yield call(deleteOrganisationDepartmentApi, payload);
    if (response) {
      yield put(deleteOrganisationDepartmentSuccess(response));
    } else {
      yield put(deleteOrganisationDepartmentFail(response));
    }
  } catch (error) {
    yield put(deleteOrganisationDepartmentFail(error));
  }
}

export function* watchDeleteOrganisationDepartment() {
  yield takeEvery(
    DELETE_ORGANISATION_DEPARTMENT,
    onDeleteOrganisationDepartment
  );
}

//get staff to staff manager list
function* onGetStaffToStaffManagerList() {
  try {
    const response = yield call(getStaffToStaffManagerListApi);
    if (response) {
      yield put(getStaffToStaffManagerListSuccess(response));
    } else {
      yield put(getStaffToStaffManagerListFail(response));
    }
  } catch (error) {
    yield put(getStaffToStaffManagerListFail(error));
  }
}

export function* watchGetStaffToStaffManagerList() {
  yield takeEvery(
    GET_STAFF_TO_STAFF_MANAGER_LIST,
    onGetStaffToStaffManagerList
  );
}

//get staff to staff manager data
function* onGetStaffToStaffManagerData({ payload }) {
  try {
    const response = yield call(getStaffToStaffManagerDataApi, payload);
    if (response) {
      yield put(getStaffToStaffManagerDataSuccess(response));
    } else {
      yield put(getStaffToStaffManagerDataFail(response));
    }
  } catch (error) {
    yield put(getStaffToStaffManagerDataFail(error));
  }
}

export function* watchGetStaffToStaffManagerData() {
  yield takeEvery(
    GET_STAFF_TO_STAFF_MANAGER_DATA,
    onGetStaffToStaffManagerData
  );
}

//create staff to staff manager
function* onCreateStaffToStaffManager({ payload }) {
  try {
    const response = yield call(createStaffToStaffManagerApi, payload);
    if (response) {
      yield put(createStaffToStaffManagerSuccess(response));
    } else {
      yield put(createStaffToStaffManagerFail(response));
    }
  } catch (error) {
    yield put(createStaffToStaffManagerFail(error));
  }
}

export function* watchCreateStaffToStaffManager() {
  yield takeEvery(CREATE_STAFF_TO_STAFF_MANAGER, onCreateStaffToStaffManager);
}

//update staff to staff manager
function* onUpdateStaffToStaffManager({ payload }) {
  try {
    const response = yield call(updateStaffToStaffManagerApi, payload);
    if (response) {
      yield put(updateStaffToStaffManagerSuccess(response));
    } else {
      yield put(updateStaffToStaffManagerFail(response));
    }
  } catch (error) {
    yield put(updateStaffToStaffManagerFail(error));
  }
}

export function* watchUpdateStaffToStaffManager() {
  yield takeEvery(UPDATE_STAFF_TO_STAFF_MANAGER, onUpdateStaffToStaffManager);
}

//delete staff to staff manager
function* onDeleteStaffToStaffManager({ payload }) {
  try {
    const response = yield call(deleteStaffToStaffManagerApi, payload);
    if (response) {
      yield put(deleteStaffToStaffManagerSuccess(response));
    } else {
      yield put(deleteStaffToStaffManagerFail(response));
    }
  } catch (error) {
    yield put(deleteStaffToStaffManagerFail(error));
  }
}

export function* watchDeleteStaffToStaffManager() {
  yield takeEvery(DELETE_STAFF_TO_STAFF_MANAGER, onDeleteStaffToStaffManager);
}

//get staff recent activity list
function* onGetStaffRecentActivityList({ payload }) {
  try {
    const response = yield call(getStaffRecentActivityListApi, payload);
    if (response) {
      yield put(getStaffRecentActivityListSuccess(response));
    } else {
      yield put(getStaffRecentActivityListFail(response));
    }
  } catch (error) {
    yield put(getStaffRecentActivityListFail(error));
  }
}

export function* watchGetStaffRecentActivityList() {
  yield takeEvery(GET_STAFF_RECENT_ACTIVITY_LIST, onGetStaffRecentActivityList);
}

//search the date-ranged staff activity log
function* onStaffActivityLogSearch({ payload }) {
  try {
    const response = yield call(staffActivityLogSearchApi, payload);
    yield put(staffActivityLogSearchSuccess(response));
  } catch (error) {
    yield put(staffActivityLogSearchFailure(error));
  }
}

// takeLatest, not takeEvery: the user can scrub the date range quickly and only
// the newest search's result should win.
export function* watchStaffActivityLogSearch() {
  yield takeLatest(STAFF_ACTIVITY_LOG_SEARCH, onStaffActivityLogSearch);
}

//search staff real time
function* onSearchStaffRealTime({ payload }) {
  try {
    const response = yield call(searchStaffRealTimeApi, payload);
    if (response) {
      yield put(searchStaffRealTimeSuccess(response));
    } else {
      yield put(searchStaffRealTimeFail(response));
    }
  } catch (error) {
    yield put(searchStaffRealTimeFail(error));
  }
}

export function* watchSearchStaffRealTime() {
  yield takeEvery(SEARCH_STAFF_REAL_TIME, onSearchStaffRealTime);
}

//GET_STAFF_SKILL_SET_LIST
function* onGetStaffSkillSetList() {
  try {
    const response = yield call(getStaffSkillSetListApi);
    if (response) {
      yield put(getStaffSkillSetListSuccess(response));
    } else {
      yield put(getStaffSkillSetListFail(response));
    }
  } catch (error) {
    yield put(getStaffSkillSetListFail(error));
  }
}

export function* watchGetStaffSkillSetList() {
  yield takeEvery(GET_STAFF_SKILL_SET_LIST, onGetStaffSkillSetList);
}

//GET_STAFF_SKILL_SET_DATA
function* onGetStaffSkillSetData({ payload }) {
  try {
    const response = yield call(getStaffSkillSetDataApi, payload);
    if (response) {
      yield put(getStaffSkillSetDataSuccess(response));
    } else {
      yield put(getStaffSkillSetDataFail(response));
    }
  } catch (error) {
    yield put(getStaffSkillSetDataFail(error));
  }
}

export function* watchGetStaffSkillSetData() {
  yield takeEvery(GET_STAFF_SKILL_SET_DATA, onGetStaffSkillSetData);
}

//CREATE_STAFF_SKILL_SET
function* onCreateStaffSkillSet({ payload }) {
  try {
    const response = yield call(createStaffSkillSetApi, payload);
    if (response) {
      yield put(createStaffSkillSetSuccess(response));
    } else {
      yield put(createStaffSkillSetFail(response));
    }
  } catch (error) {
    yield put(createStaffSkillSetFail(error));
  }
}

export function* watchCreateStaffSkillSet() {
  yield takeEvery(CREATE_STAFF_SKILL_SET, onCreateStaffSkillSet);
}

//UPDATE_STAFF_SKILL_SET
function* onUpdateStaffSkillSet({ payload }) {
  try {
    const response = yield call(updateStaffSkillSetApi, payload);
    if (response) {
      yield put(updateStaffSkillSetSuccess(response));
    } else {
      yield put(updateStaffSkillSetFail(response));
    }
  } catch (error) {
    yield put(updateStaffSkillSetFail(error));
  }
}

export function* watchUpdateStaffSkillSet() {
  yield takeEvery(UPDATE_STAFF_SKILL_SET, onUpdateStaffSkillSet);
}

//DELETE_STAFF_SKILL_SET
function* onDeleteStaffSkillSet({ payload }) {
  try {
    const response = yield call(deleteStaffSkillSetApi, payload);
    if (response) {
      yield put(deleteStaffSkillSetSuccess(response));
    } else {
      yield put(deleteStaffSkillSetFail(response));
    }
  } catch (error) {
    yield put(deleteStaffSkillSetFail(error));
  }
}

export function* watchDeleteStaffSkillSet() {
  yield takeEvery(DELETE_STAFF_SKILL_SET, onDeleteStaffSkillSet);
}

//GET_STAFF_TO_STAFF_SKILL_SET_LIST
function* onGetStaffToStaffSkillSetList() {
  try {
    const response = yield call(getStaffToStaffSkillSetListApi);
    if (response) {
      yield put(getStaffToStaffSkillSetListSuccess(response));
    } else {
      yield put(getStaffToStaffSkillSetListFail(response));
    }
  } catch (error) {
    yield put(getStaffToStaffSkillSetListFail(error));
  }
}

export function* watchGetStaffToStaffSkillSetList() {
  yield takeEvery(
    GET_STAFF_TO_STAFF_SKILL_SET_LIST,
    onGetStaffToStaffSkillSetList
  );
}

//GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST
function* onGetActiveStaffToStaffSkillSetList() {
  try {
    const response = yield call(getActiveStaffToStaffSkillSetListApi);
    if (response) {
      yield put(getActiveStaffToStaffSkillSetListSuccess(response));
    } else {
      yield put(getActiveStaffToStaffSkillSetListFail(response));
    }
  } catch (error) {
    yield put(getActiveStaffToStaffSkillSetListFail(error));
  }
}

export function* watchGetActiveStaffToStaffSkillSetList() {
  yield takeEvery(
    GET_ACTIVE_STAFF_TO_STAFF_SKILL_SET_LIST,
    onGetActiveStaffToStaffSkillSetList
  );
}

//GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST
function* onGetExpiredStaffToStaffSkillSetList() {
  try {
    const response = yield call(getExpiredStaffToStaffSkillSetListApi);
    if (response) {
      yield put(getExpiredStaffToStaffSkillSetListSuccess(response));
    } else {
      yield put(getExpiredStaffToStaffSkillSetListFail(response));
    }
  } catch (error) {
    yield put(getExpiredStaffToStaffSkillSetListFail(error));
  }
}

export function* watchGetExpiredStaffToStaffSkillSetList() {
  yield takeEvery(
    GET_EXPIRED_STAFF_TO_STAFF_SKILL_SET_LIST,
    onGetExpiredStaffToStaffSkillSetList
  );
}

//GET_STAFF_TO_STAFF_SKILL_SET_DATA
function* onGetStaffToStaffSkillSetData({ payload }) {
  try {
    const response = yield call(getStaffToStaffSkillSetDataApi, payload);
    if (response) {
      yield put(getStaffToStaffSkillSetDataSuccess(response));
    } else {
      yield put(getStaffToStaffSkillSetDataFail(response));
    }
  } catch (error) {
    yield put(getStaffToStaffSkillSetDataFail(error));
  }
}

export function* watchGetStaffToStaffSkillSetData() {
  yield takeEvery(
    GET_STAFF_TO_STAFF_SKILL_SET_DATA,
    onGetStaffToStaffSkillSetData
  );
}

//CREATE_STAFF_TO_STAFF_SKILL_SET
function* onCreateStaffToStaffSkillSet({ payload }) {
  try {
    const response = yield call(createStaffToStaffSkillSetApi, payload);
    if (response) {
      yield put(createStaffToStaffSkillSetSuccess(response));
    } else {
      yield put(createStaffToStaffSkillSetFail(response));
    }
  } catch (error) {
    yield put(createStaffToStaffSkillSetFail(error));
  }
}

export function* watchCreateStaffToStaffSkillSet() {
  yield takeEvery(
    CREATE_STAFF_TO_STAFF_SKILL_SET,
    onCreateStaffToStaffSkillSet
  );
}

//UPDATE_STAFF_TO_STAFF_SKILL_SET
function* onUpdateStaffToStaffSkillSet({ payload }) {
  try {
    const response = yield call(updateStaffToStaffSkillSetApi, payload);
    if (response) {
      yield put(updateStaffToStaffSkillSetSuccess(response));
    } else {
      yield put(updateStaffToStaffSkillSetFail(response));
    }
  } catch (error) {
    yield put(updateStaffToStaffSkillSetFail(error));
  }
}

export function* watchUpdateStaffToStaffSkillSet() {
  yield takeEvery(
    UPDATE_STAFF_TO_STAFF_SKILL_SET,
    onUpdateStaffToStaffSkillSet
  );
}

//DELETE_STAFF_TO_STAFF_SKILL_SET
function* onDeleteStaffToStaffSkillSet({ payload }) {
  try {
    const response = yield call(deleteStaffToStaffSkillSetApi, payload);
    if (response) {
      yield put(deleteStaffToStaffSkillSetSuccess(response));
    } else {
      yield put(deleteStaffToStaffSkillSetFail(response));
    }
  } catch (error) {
    yield put(deleteStaffToStaffSkillSetFail(error));
  }
}

export function* watchDeleteStaffToStaffSkillSet() {
  yield takeEvery(
    DELETE_STAFF_TO_STAFF_SKILL_SET,
    onDeleteStaffToStaffSkillSet
  );
}

//SEARCH_STAFF_TO_STAFF_SKILL_SET
function* onSearchStaffToStaffSkillSet({ payload }) {
  try {
    const response = yield call(searchStaffToStaffSkillSetApi, payload);
    if (response) {
      yield put(searchStaffToStaffSkillSetSuccess(response));
    } else {
      yield put(searchStaffToStaffSkillSetFail(response));
    }
  } catch (error) {
    yield put(searchStaffToStaffSkillSetFail(error));
  }
}

export function* watchSearchStaffToStaffSkillSet() {
  yield takeEvery(
    SEARCH_STAFF_TO_STAFF_SKILL_SET,
    onSearchStaffToStaffSkillSet
  );
}

//SEARCH_STAFF_AVAILABILITY
function* onSearchStaffAvailability({ payload }) {
  try {
    const response = yield call(searchStaffAvailabilityApi, payload);
    if (response) {
      yield put(searchStaffAvailabilitySuccess(response));
    } else {
      yield put(searchStaffAvailabilityFail(response));
    }
  } catch (error) {
    yield put(searchStaffAvailabilityFail(error));
  }
}

export function* watchSearchStaffAvailability() {
  yield takeEvery(SEARCH_STAFF_AVAILABILITY, onSearchStaffAvailability);
}

//SEARCH_STAFF_GPS_LOCATION_HISTORY
function* onSearchStaffGPSLocationHistory({ payload }) {
  try {
    const response = yield call(searchStaffGPSLocationHistoryApi, payload);
    if (response) {
      yield put(searchStaffGPSLocationHistorySuccess(response));
    } else {
      yield put(searchStaffGPSLocationHistoryFail(response));
    }
  } catch (error) {
    yield put(searchStaffGPSLocationHistoryFail(error));
  }
}

export function* watchSearchStaffGPSLocationHistory() {
  yield takeEvery(
    SEARCH_STAFF_GPS_LOCATION_HISTORY,
    onSearchStaffGPSLocationHistory
  );
}

//getStaffWorkingScheduleRecordList
function* onGetStaffWorkingScheduleRecordList() {
  try {
    const response = yield call(getStaffWorkingScheduleRecordListApi);
    if (response) {
      yield put(getStaffWorkingScheduleRecordListSuccess(response));
    } else {
      yield put(getStaffWorkingScheduleRecordListFail(response));
    }
  } catch (error) {
    yield put(getStaffWorkingScheduleRecordListFail(error));
  }
}

export function* watchGetStaffWorkingScheduleRecordList() {
  yield takeEvery(
    GET_STAFF_WORKING_SCHEDULE_RECORD_LIST,
    onGetStaffWorkingScheduleRecordList
  );
}

//getStaffWorkingScheduleRecordData
function* onGetStaffWorkingScheduleRecordData({ payload }) {
  try {
    const response = yield call(getStaffWorkingScheduleRecordDataApi, payload);
    if (response) {
      yield put(getStaffWorkingScheduleRecordDataSuccess(response));
    } else {
      yield put(getStaffWorkingScheduleRecordDataFail(response));
    }
  } catch (error) {
    yield put(getStaffWorkingScheduleRecordDataFail(error));
  }
}

export function* watchGetStaffWorkingScheduleRecordData() {
  yield takeEvery(
    GET_STAFF_WORKING_SCHEDULE_RECORD_DATA,
    onGetStaffWorkingScheduleRecordData
  );
}

//createStaffWorkingScheduleRecord
function* onCreateStaffWorkingScheduleRecord({ payload }) {
  try {
    const response = yield call(createStaffWorkingScheduleRecordApi, payload);
    if (response) {
      yield put(createStaffWorkingScheduleRecordSuccess(response));
    } else {
      yield put(createStaffWorkingScheduleRecordFail(response));
    }
  } catch (error) {
    yield put(createStaffWorkingScheduleRecordFail(error));
  }
}

export function* watchCreateStaffWorkingScheduleRecord() {
  yield takeEvery(
    CREATE_STAFF_WORKING_SCHEDULE_RECORD,
    onCreateStaffWorkingScheduleRecord
  );
}

//updateStaffWorkingScheduleRecord
function* onUpdateStaffWorkingScheduleRecord({ payload }) {
  try {
    const response = yield call(updateStaffWorkingScheduleRecordApi, payload);
    if (response) {
      yield put(updateStaffWorkingScheduleRecordSuccess(response));
    } else {
      yield put(updateStaffWorkingScheduleRecordFail(response));
    }
  } catch (error) {
    yield put(updateStaffWorkingScheduleRecordFail(error));
  }
}

export function* watchUpdateStaffWorkingScheduleRecord() {
  yield takeEvery(
    UPDATE_STAFF_WORKING_SCHEDULE_RECORD,
    onUpdateStaffWorkingScheduleRecord
  );
}

//deleteStaffWorkingScheduleRecord
function* onDeleteStaffWorkingScheduleRecord({ payload }) {
  try {
    const response = yield call(deleteStaffWorkingScheduleRecordApi, payload);
    if (response) {
      yield put(deleteStaffWorkingScheduleRecordSuccess(response));
    } else {
      yield put(deleteStaffWorkingScheduleRecordFail(response));
    }
  } catch (error) {
    yield put(deleteStaffWorkingScheduleRecordFail(error));
  }
}

export function* watchDeleteStaffWorkingScheduleRecord() {
  yield takeEvery(
    DELETE_STAFF_WORKING_SCHEDULE_RECORD,
    onDeleteStaffWorkingScheduleRecord
  );
}

//getStaffWorkingScheduleRecordAdjustmentList
function* onGetStaffWorkingScheduleRecordAdjustmentList() {
  try {
    const response = yield call(getStaffWorkingScheduleRecordAdjustmentListApi);
    if (response) {
      yield put(getStaffWorkingScheduleRecordAdjustmentListSuccess(response));
    } else {
      yield put(getStaffWorkingScheduleRecordAdjustmentListFail(response));
    }
  } catch (error) {
    yield put(getStaffWorkingScheduleRecordAdjustmentListFail(error));
  }
}

export function* watchGetStaffWorkingScheduleRecordAdjustmentList() {
  yield takeEvery(
    GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_LIST,
    onGetStaffWorkingScheduleRecordAdjustmentList
  );
}

//getStaffWorkingScheduleRecordAdjustmentData
function* onGetStaffWorkingScheduleRecordAdjustmentData({ payload }) {
  try {
    const response = yield call(
      getStaffWorkingScheduleRecordAdjustmentDataApi,
      payload
    );
    if (response) {
      yield put(getStaffWorkingScheduleRecordAdjustmentDataSuccess(response));
    } else {
      yield put(getStaffWorkingScheduleRecordAdjustmentDataFail(response));
    }
  } catch (error) {
    yield put(getStaffWorkingScheduleRecordAdjustmentDataFail(error));
  }
}

export function* watchGetStaffWorkingScheduleRecordAdjustmentData() {
  yield takeEvery(
    GET_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT_DATA,
    onGetStaffWorkingScheduleRecordAdjustmentData
  );
}

//createStaffWorkingScheduleRecordAdjustment
function* onCreateStaffWorkingScheduleRecordAdjustment({ payload }) {
  try {
    const response = yield call(
      createStaffWorkingScheduleRecordAdjustmentApi,
      payload
    );
    if (response) {
      yield put(createStaffWorkingScheduleRecordAdjustmentSuccess(response));
    } else {
      yield put(createStaffWorkingScheduleRecordAdjustmentFail(response));
    }
  } catch (error) {
    yield put(createStaffWorkingScheduleRecordAdjustmentFail(error));
  }
}

export function* watchCreateStaffWorkingScheduleRecordAdjustment() {
  yield takeEvery(
    CREATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
    onCreateStaffWorkingScheduleRecordAdjustment
  );
}

//updateStaffWorkingScheduleRecordAdjustment
function* onUpdateStaffWorkingScheduleRecordAdjustment({ payload }) {
  try {
    const response = yield call(
      updateStaffWorkingScheduleRecordAdjustmentApi,
      payload
    );
    if (response) {
      yield put(updateStaffWorkingScheduleRecordAdjustmentSuccess(response));
    } else {
      yield put(updateStaffWorkingScheduleRecordAdjustmentFail(response));
    }
  } catch (error) {
    yield put(updateStaffWorkingScheduleRecordAdjustmentFail(error));
  }
}

export function* watchUpdateStaffWorkingScheduleRecordAdjustment() {
  yield takeEvery(
    UPDATE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
    onUpdateStaffWorkingScheduleRecordAdjustment
  );
}

//deleteStaffWorkingScheduleRecordAdjustment
function* onDeleteStaffWorkingScheduleRecordAdjustment({ payload }) {
  try {
    const response = yield call(
      deleteStaffWorkingScheduleRecordAdjustmentApi,
      payload
    );
    if (response) {
      yield put(deleteStaffWorkingScheduleRecordAdjustmentSuccess(response));
    } else {
      yield put(deleteStaffWorkingScheduleRecordAdjustmentFail(response));
    }
  } catch (error) {
    yield put(deleteStaffWorkingScheduleRecordAdjustmentFail(error));
  }
}

export function* watchDeleteStaffWorkingScheduleRecordAdjustment() {
  yield takeEvery(
    DELETE_STAFF_WORKING_SCHEDULE_RECORD_ADJUSTMENT,
    onDeleteStaffWorkingScheduleRecordAdjustment
  );
}

//getStaffWorkingScheduleList
function* onGetStaffWorkingScheduleList() {
  try {
    const response = yield call(getStaffWorkingScheduleListApi);
    if (response) {
      yield put(getStaffWorkingScheduleListSuccess(response));
    } else {
      yield put(getStaffWorkingScheduleListFail(response));
    }
  } catch (error) {
    yield put(getStaffWorkingScheduleListFail(error));
  }
}

export function* watchGetStaffWorkingScheduleList() {
  yield takeEvery(
    GET_STAFF_WORKING_SCHEDULE_LIST,
    onGetStaffWorkingScheduleList
  );
}

//getStaffWorkingScheduleData
function* onGetStaffWorkingScheduleData({ payload }) {
  try {
    const response = yield call(getStaffWorkingScheduleDataApi, payload);
    if (response) {
      yield put(getStaffWorkingScheduleDataSuccess(response));
    } else {
      yield put(getStaffWorkingScheduleDataFail(response));
    }
  } catch (error) {
    yield put(getStaffWorkingScheduleDataFail(error));
  }
}

export function* watchGetStaffWorkingScheduleData() {
  yield takeEvery(
    GET_STAFF_WORKING_SCHEDULE_DATA,
    onGetStaffWorkingScheduleData
  );
}

//createStaffWorkingSchedule
function* onCreateStaffWorkingSchedule({ payload }) {
  try {
    const response = yield call(createStaffWorkingScheduleApi, payload);
    if (response) {
      yield put(createStaffWorkingScheduleSuccess(response));
    } else {
      yield put(createStaffWorkingScheduleFail(response));
    }
  } catch (error) {
    yield put(createStaffWorkingScheduleFail(error));
  }
}

export function* watchCreateStaffWorkingSchedule() {
  yield takeEvery(CREATE_STAFF_WORKING_SCHEDULE, onCreateStaffWorkingSchedule);
}

//updateStaffWorkingSchedule
function* onUpdateStaffWorkingSchedule({ payload }) {
  try {
    const response = yield call(updateStaffWorkingScheduleApi, payload);
    if (response) {
      yield put(updateStaffWorkingScheduleSuccess(response));
    } else {
      yield put(updateStaffWorkingScheduleFail(response));
    }
  } catch (error) {
    yield put(updateStaffWorkingScheduleFail(error));
  }
}

export function* watchUpdateStaffWorkingSchedule() {
  yield takeEvery(UPDATE_STAFF_WORKING_SCHEDULE, onUpdateStaffWorkingSchedule);
}

//deleteStaffWorkingSchedule
function* onDeleteStaffWorkingSchedule({ payload }) {
  try {
    const response = yield call(deleteStaffWorkingScheduleApi, payload);
    if (response) {
      yield put(deleteStaffWorkingScheduleSuccess(response));
    } else {
      yield put(deleteStaffWorkingScheduleFail(response));
    }
  } catch (error) {
    yield put(deleteStaffWorkingScheduleFail(error));
  }
}

export function* watchDeleteStaffWorkingSchedule() {
  yield takeEvery(DELETE_STAFF_WORKING_SCHEDULE, onDeleteStaffWorkingSchedule);
}

//SEARCH_STAFF_WORKING_SCHEDULE
function* onSearchStaffWorkingSchedule({ payload }) {
  try {
    const response = yield call(searchStaffWorkingScheduleApi, payload);
    if (response) {
      yield put(searchStaffWorkingScheduleSuccess(response));
    } else {
      yield put(searchStaffWorkingScheduleFail(response));
    }
  } catch (error) {
    yield put(searchStaffWorkingScheduleFail(error));
  }
}

export function* watchSearchStaffWorkingSchedule() {
  yield takeEvery(SEARCH_STAFF_WORKING_SCHEDULE, onSearchStaffWorkingSchedule);
}

//SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE (isolated channel — same endpoint)
function* onSearchStaffWorkingScheduleForClone({ payload }) {
  try {
    const response = yield call(searchStaffWorkingScheduleApi, payload);
    if (response) {
      yield put(searchStaffWorkingScheduleForCloneSuccess(response));
    } else {
      yield put(searchStaffWorkingScheduleForCloneFail(response));
    }
  } catch (error) {
    yield put(searchStaffWorkingScheduleForCloneFail(error));
  }
}

export function* watchSearchStaffWorkingScheduleForClone() {
  yield takeEvery(
    SEARCH_STAFF_WORKING_SCHEDULE_FOR_CLONE,
    onSearchStaffWorkingScheduleForClone
  );
}

//CALCULATE_STAFF_WORKING_SCHEDULE
function* onCalculateStaffWorkingSchedule({ payload }) {
  try {
    const response = yield call(calculateStaffWorkingScheduleApi, payload);
    if (response) {
      yield put(calculateStaffWorkingScheduleSuccess(response));
    } else {
      yield put(calculateStaffWorkingScheduleFail(response));
    }
  } catch (error) {
    yield put(calculateStaffWorkingScheduleFail(error));
  }
}

export function* watchCalculateStaffWorkingSchedule() {
  yield takeEvery(
    CALCULATE_STAFF_WORKING_SCHEDULE,
    onCalculateStaffWorkingSchedule
  );
}

// main Saga Function
function* staffSaga() {
  yield all([
    fork(watchAddStaff),
    fork(watchGetStaffData),
    fork(watchUpdateStaff),
    fork(watchDeleteStaff),
    fork(watchGetStaffList),
    fork(watchSearchStaffIncomeList),
    fork(watchGetStaffLeaveTypeList),
    fork(watchAddStaffLeaveType),
    fork(watchUpdateStaffLeaveType),
    fork(watchDeleteStaffLeaveType),
    fork(watchCreateStaffIncome),
    fork(watchGetStaffIncomeCategoryItemList),
    fork(watchGetStaffIncomeCategoryItemData),
    fork(watchCreateStaffIncomeCategoryItem),
    fork(watchUpdateStaffIncomeCategoryItem),
    fork(watchDeleteStaffIncomeCategoryItem),
    fork(watchGetStaffIncomeList),
    fork(watchGetStaffIncomeData),
    fork(watchUpdateStaffIncome),
    fork(watchDeleteStaffIncome),
    fork(watchGetStaffLeaveList),
    fork(watchGetStaffLeaveData),
    fork(watchUpdateStaffLeave),
    fork(watchDeleteStaffLeave),
    fork(watchCreateStaffLeave),
    fork(watchSearchStaffLeave),
    fork(watchGetStaffLeaveAllowanceList),
    fork(watchGetStaffLeaveAllowanceData),
    fork(watchUpdateStaffLeaveAllowance),
    fork(watchDeleteStaffLeaveAllowance),
    fork(watchCreateStaffLeaveAllowance),
    fork(watchSearchStaffLeaveAllowance),
    fork(watchSearchStaff),
    fork(watchSearchStaffMembers),
    fork(watchCreateStaffAndUser),
    fork(watchGetOrganisationDepartmentToStaffList),
    fork(watchGetOrganisationDepartmentToStaffData),
    fork(watchCreateOrganisationDepartmentToStaff),
    fork(watchSearchOrganisationDepartmentToStaff),
    fork(watchUpdateOrganisationDepartmentToStaff),
    fork(watchDeleteOrganisationDepartmentToStaff),
    fork(watchGetOrganisationDepartmentList),
    fork(watchGetOrganisationDepartmentData),
    fork(watchCreateOrganisationDepartment),
    fork(watchGetOrganisationDepartmentHierarchyEnquiry),
    fork(watchUpdateOrganisationDepartment),
    fork(watchDeleteOrganisationDepartment),
    fork(watchGetStaffToStaffManagerList),
    fork(watchGetStaffToStaffManagerData),
    fork(watchCreateStaffToStaffManager),
    fork(watchUpdateStaffToStaffManager),
    fork(watchDeleteStaffToStaffManager),
    fork(watchGetStaffRecentActivityList),
    fork(watchSearchStaffRealTime),
    fork(watchGetStaffSkillSetList),
    fork(watchGetStaffSkillSetData),
    fork(watchCreateStaffSkillSet),
    fork(watchUpdateStaffSkillSet),
    fork(watchDeleteStaffSkillSet),
    fork(watchGetStaffToStaffSkillSetList),
    fork(watchGetActiveStaffToStaffSkillSetList),
    fork(watchGetExpiredStaffToStaffSkillSetList),
    fork(watchGetStaffToStaffSkillSetData),
    fork(watchCreateStaffToStaffSkillSet),
    fork(watchUpdateStaffToStaffSkillSet),
    fork(watchDeleteStaffToStaffSkillSet),
    fork(watchSearchStaffToStaffSkillSet),
    fork(watchSearchStaffAvailability),
    fork(watchSearchStaffGPSLocationHistory),
    fork(watchGetStaffWorkingScheduleRecordList),
    fork(watchGetStaffWorkingScheduleRecordData),
    fork(watchCreateStaffWorkingScheduleRecord),
    fork(watchUpdateStaffWorkingScheduleRecord),
    fork(watchDeleteStaffWorkingScheduleRecord),
    fork(watchGetStaffWorkingScheduleRecordAdjustmentList),
    fork(watchGetStaffWorkingScheduleRecordAdjustmentData),
    fork(watchCreateStaffWorkingScheduleRecordAdjustment),
    fork(watchUpdateStaffWorkingScheduleRecordAdjustment),
    fork(watchDeleteStaffWorkingScheduleRecordAdjustment),
    fork(watchGetStaffWorkingScheduleList),
    fork(watchGetStaffWorkingScheduleData),
    fork(watchCreateStaffWorkingSchedule),
    fork(watchUpdateStaffWorkingSchedule),
    fork(watchDeleteStaffWorkingSchedule),
    fork(watchSearchStaffWorkingSchedule),
    fork(watchSearchStaffWorkingScheduleForClone),
    fork(watchCalculateStaffWorkingSchedule),
    fork(watchStaffActivityLogSearch),
  ]);
}

export default staffSaga;
